module.exports = __webpack_public_path__ + "static/media/validar.b0bb7214.png";